// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","bottom":"Footer_bottom__J7kjW","content":"Footer_content__tUe-I","contentContainer":"Footer_contentContainer__+J7VA","links":"Footer_links__2VAlO"};